export default __webpack_public_path__ + "static/media/Circly_List_Insertion_3.debc0575.gif";